import { addTLMDSchema } from "../../../../schemas/index.js";
import { COMMON_TLMD_SCHEMAS } from "./common.schema.js";
import { FREQUENCY_PLOT_CONFIGURATION_TLMD_SCHEMAS } from "./configuration.schema.js";
Object.values(COMMON_TLMD_SCHEMAS).forEach(tlmdSchema => {
    addTLMDSchema(tlmdSchema);
});
Object.values(FREQUENCY_PLOT_CONFIGURATION_TLMD_SCHEMAS).forEach(tlmdSchema => {
    addTLMDSchema(tlmdSchema);
});
